// extracted by mini-css-extract-plugin
export default {"lockableDecoratorContainer":"styles_lockableDecoratorContainer__m8cbg","decoratedComponentWrapper":"styles_decoratedComponentWrapper__nHnFs","lockButton":"styles_lockButton__CwvqK"};